/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { queriesGet$Json } from '../fn/queries/queries-get-json';
import { QueriesGet$Json$Params } from '../fn/queries/queries-get-json';
import { queriesGet$Plain } from '../fn/queries/queries-get-plain';
import { QueriesGet$Plain$Params } from '../fn/queries/queries-get-plain';
import { queriesPost$Json } from '../fn/queries/queries-post-json';
import { QueriesPost$Json$Params } from '../fn/queries/queries-post-json';
import { queriesPost$Plain } from '../fn/queries/queries-post-plain';
import { QueriesPost$Plain$Params } from '../fn/queries/queries-post-plain';
import { queriesQueryIdClonePost$Json } from '../fn/queries/queries-query-id-clone-post-json';
import { QueriesQueryIdClonePost$Json$Params } from '../fn/queries/queries-query-id-clone-post-json';
import { queriesQueryIdClonePost$Plain } from '../fn/queries/queries-query-id-clone-post-plain';
import { QueriesQueryIdClonePost$Plain$Params } from '../fn/queries/queries-query-id-clone-post-plain';
import { queriesQueryIdDelete } from '../fn/queries/queries-query-id-delete';
import { QueriesQueryIdDelete$Params } from '../fn/queries/queries-query-id-delete';
import { queriesQueryIdGet$Json } from '../fn/queries/queries-query-id-get-json';
import { QueriesQueryIdGet$Json$Params } from '../fn/queries/queries-query-id-get-json';
import { queriesQueryIdGet$Plain } from '../fn/queries/queries-query-id-get-plain';
import { QueriesQueryIdGet$Plain$Params } from '../fn/queries/queries-query-id-get-plain';
import { queriesQueryIdPut$Json } from '../fn/queries/queries-query-id-put-json';
import { QueriesQueryIdPut$Json$Params } from '../fn/queries/queries-query-id-put-json';
import { queriesQueryIdPut$Plain } from '../fn/queries/queries-query-id-put-plain';
import { QueriesQueryIdPut$Plain$Params } from '../fn/queries/queries-query-id-put-plain';
import { QueryDto } from '../models/query-dto';

@Injectable({ providedIn: 'root' })
export class QueriesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `queriesGet()` */
  static readonly QueriesGetPath = '/queries';

  /**
   * List queries.
   *
   * Returns saved queries, optionally filtered by search term.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queriesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  queriesGet$Plain$Response(params?: QueriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<QueryDto>>> {
    const obs = queriesGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List queries.
   *
   * Returns saved queries, optionally filtered by search term.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queriesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  queriesGet$Plain(params?: QueriesGet$Plain$Params, context?: HttpContext): Observable<Array<QueryDto>> {
    const resp = this.queriesGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<QueryDto>>): Array<QueryDto> => r.body)
    );
  }

  /**
   * List queries.
   *
   * Returns saved queries, optionally filtered by search term.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queriesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  queriesGet$Json$Response(params?: QueriesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<QueryDto>>> {
    const obs = queriesGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List queries.
   *
   * Returns saved queries, optionally filtered by search term.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queriesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  queriesGet$Json(params?: QueriesGet$Json$Params, context?: HttpContext): Observable<Array<QueryDto>> {
    const resp = this.queriesGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<QueryDto>>): Array<QueryDto> => r.body)
    );
  }

  /** Path part for operation `queriesPost()` */
  static readonly QueriesPostPath = '/queries';

  /**
   * Create query.
   *
   * Creates a new saved query in the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queriesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queriesPost$Plain$Response(params?: QueriesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
    const obs = queriesPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create query.
   *
   * Creates a new saved query in the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queriesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queriesPost$Plain(params?: QueriesPost$Plain$Params, context?: HttpContext): Observable<QueryDto> {
    const resp = this.queriesPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryDto>): QueryDto => r.body)
    );
  }

  /**
   * Create query.
   *
   * Creates a new saved query in the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queriesPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queriesPost$Json$Response(params?: QueriesPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
    const obs = queriesPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create query.
   *
   * Creates a new saved query in the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queriesPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queriesPost$Json(params?: QueriesPost$Json$Params, context?: HttpContext): Observable<QueryDto> {
    const resp = this.queriesPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryDto>): QueryDto => r.body)
    );
  }

  /** Path part for operation `queriesQueryIdGet()` */
  static readonly QueriesQueryIdGetPath = '/queries/{queryId}';

  /**
   * Get query.
   *
   * Gets a saved query definition by id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queriesQueryIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  queriesQueryIdGet$Plain$Response(params: QueriesQueryIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
    const obs = queriesQueryIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get query.
   *
   * Gets a saved query definition by id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queriesQueryIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  queriesQueryIdGet$Plain(params: QueriesQueryIdGet$Plain$Params, context?: HttpContext): Observable<QueryDto> {
    const resp = this.queriesQueryIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryDto>): QueryDto => r.body)
    );
  }

  /**
   * Get query.
   *
   * Gets a saved query definition by id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queriesQueryIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  queriesQueryIdGet$Json$Response(params: QueriesQueryIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
    const obs = queriesQueryIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get query.
   *
   * Gets a saved query definition by id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queriesQueryIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  queriesQueryIdGet$Json(params: QueriesQueryIdGet$Json$Params, context?: HttpContext): Observable<QueryDto> {
    const resp = this.queriesQueryIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryDto>): QueryDto => r.body)
    );
  }

  /** Path part for operation `queriesQueryIdPut()` */
  static readonly QueriesQueryIdPutPath = '/queries/{queryId}';

  /**
   * Update query.
   *
   * Updates name, description and builder config of a saved query.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queriesQueryIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queriesQueryIdPut$Plain$Response(params: QueriesQueryIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
    const obs = queriesQueryIdPut$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update query.
   *
   * Updates name, description and builder config of a saved query.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queriesQueryIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queriesQueryIdPut$Plain(params: QueriesQueryIdPut$Plain$Params, context?: HttpContext): Observable<QueryDto> {
    const resp = this.queriesQueryIdPut$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryDto>): QueryDto => r.body)
    );
  }

  /**
   * Update query.
   *
   * Updates name, description and builder config of a saved query.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queriesQueryIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queriesQueryIdPut$Json$Response(params: QueriesQueryIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
    const obs = queriesQueryIdPut$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update query.
   *
   * Updates name, description and builder config of a saved query.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queriesQueryIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queriesQueryIdPut$Json(params: QueriesQueryIdPut$Json$Params, context?: HttpContext): Observable<QueryDto> {
    const resp = this.queriesQueryIdPut$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryDto>): QueryDto => r.body)
    );
  }

  /** Path part for operation `queriesQueryIdDelete()` */
  static readonly QueriesQueryIdDeletePath = '/queries/{queryId}';

  /**
   * Delete query.
   *
   * Soft-deletes a saved query.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queriesQueryIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  queriesQueryIdDelete$Response(params: QueriesQueryIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = queriesQueryIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete query.
   *
   * Soft-deletes a saved query.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queriesQueryIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  queriesQueryIdDelete(params: QueriesQueryIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.queriesQueryIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `queriesQueryIdClonePost()` */
  static readonly QueriesQueryIdClonePostPath = '/queries/{queryId}/clone';

  /**
   * Clone query.
   *
   * Creates a new query based on an existing one.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queriesQueryIdClonePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queriesQueryIdClonePost$Plain$Response(params: QueriesQueryIdClonePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
    const obs = queriesQueryIdClonePost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Clone query.
   *
   * Creates a new query based on an existing one.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queriesQueryIdClonePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queriesQueryIdClonePost$Plain(params: QueriesQueryIdClonePost$Plain$Params, context?: HttpContext): Observable<QueryDto> {
    const resp = this.queriesQueryIdClonePost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryDto>): QueryDto => r.body)
    );
  }

  /**
   * Clone query.
   *
   * Creates a new query based on an existing one.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queriesQueryIdClonePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queriesQueryIdClonePost$Json$Response(params: QueriesQueryIdClonePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
    const obs = queriesQueryIdClonePost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Clone query.
   *
   * Creates a new query based on an existing one.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queriesQueryIdClonePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  queriesQueryIdClonePost$Json(params: QueriesQueryIdClonePost$Json$Params, context?: HttpContext): Observable<QueryDto> {
    const resp = this.queriesQueryIdClonePost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<QueryDto>): QueryDto => r.body)
    );
  }

}
